export default (params) => ({
  trigger: {
    name: 'order_block.select_lease_tenure',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          '6m',
          '12m',
          '24m',
          '36m',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'lease_tenure',
      },
    },
  },
});
